// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__xcvSs","selected":"styles_selected__JAO_p"};